import { useEffect, useState } from 'react';

import FormPopup from 'components/Form/FormPopup';

const GlobalModalForm = () => {
  const [isModalOpen, toggleIsModalOpen] = useState(false);
  const [modalFormData, setModalFormData] = useState({});

  const [isHidden, setIsHidden] = useState(true);

  useEffect(() => {
    window.toggleModal = (heading: string, body: string, guid: string, driftFastlaneCampaignId: string) => {
      setIsHidden(false);
      setModalFormData({
        formType: 'Basic',
        hubspotForm: {
          guid,
        },
        heading,
        body,
        driftFastlaneCampaignId,
      });
      toggleIsModalOpen(true);
    };

    return () => {
      window.toggleModal = null;
    };
  }, []);

  return isHidden ? null : <FormPopup open={isModalOpen} onClose={() => toggleIsModalOpen(false)} {...modalFormData} />;
};

export default GlobalModalForm;
